import getSubjectListWebsite from "./getSubjectListWebsite";

const subjectWebsiteServices = {
  getSubjectListWebsite,
};

export default subjectWebsiteServices;
